// Definição para o modal de busca de Parceiros (genérica, sem filtros fixos)
// Utilizada pelo Simulador do Motor Fiscal e outros componentes que precisam
// selecionar qualquer tipo de parceiro (fornecedor, cliente, estrangeiro, etc.)

export const parceiroSearch = {
  label: 'Parceiro',
  placeholder: 'Nome ou Documento...',
  titulo: 'Selecionar Parceiro',
  endpointApi: 'Parceiros',
  idField: 'idParceiro',
  displayField: 'idParceiro',
  descField: 'nomeFantasia',
  tabela: 'Parceiro',

  camposFiltro: [
    { label: 'Nome Fantasia', model: 'busca', tipo: 'text' }
  ],

  colunasGrid: [
    { header: 'ID', dataField: 'idParceiro', width: '8%' },
    { header: 'Nome Fantasia', dataField: 'nomeFantasia', width: '30%' },
    { header: 'Documento', dataField: 'documento', width: '18%' },
    { header: 'Tipo', dataField: 'lstTipoPessoa', width: '12%' },
    { header: 'UF', dataField: 'uf', width: '8%' },
    { header: 'Regime Tributário', dataField: 'lstRegimeTributario', width: '24%' }
  ]
}
